import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b75a84cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "tp-dashboard-tab mb-30" }
const _hoisted_3 = { class: "tp-dashboard-tab-title" }
const _hoisted_4 = { class: "tpd-table mb-25" }
const _hoisted_5 = { class: "tpd-table-head" }
const _hoisted_6 = { class: "tpd-table-row" }
const _hoisted_7 = { class: "tpd-reviews-course" }
const _hoisted_8 = { class: "tpd-table-title" }
const _hoisted_9 = { class: "tpd-reviews-feedback-2" }
const _hoisted_10 = { class: "tpd-table-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tpd-reviews-edit" }, null, -1 /* HOISTED */))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"placeholder-glow\" data-v-b75a84cc><div class=\"d-flex gap-3\" data-v-b75a84cc><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\" data-v-b75a84cc></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\" data-v-b75a84cc></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\" data-v-b75a84cc></span></div></div>", 1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "alert alert-warning" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_18 = { class: "tpd-table-row" }
const _hoisted_19 = { class: "tpd-reviews-course" }
const _hoisted_20 = { class: "tpd-course-wrap" }
const _hoisted_21 = { class: "tpd-course-name" }
const _hoisted_22 = { class: "tpd-course-title mt-1 font-s-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }, null, -1 /* HOISTED */))
const _hoisted_24 = { class: "tpd-reviews-feedback-2" }
const _hoisted_25 = { class: "tp-instructor-rating" }
const _hoisted_26 = ["tooltip"]
const _hoisted_27 = { class: "tpd-action-tooltip" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-b75a84cc><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i></div>", 1)
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i><i class=\"fa fa-star\" data-v-b75a84cc></i>", 5)
const _hoisted_34 = [
  _hoisted_29
]
const _hoisted_35 = { class: "tpd-reviews-comment" }
const _hoisted_36 = {
  class: "tpd-reviews-edit",
  style: {"display":"none"}
}
const _hoisted_37 = { class: "tpd-reviews-edit-warp d-flex align-items-center justify-content-end" }
const _hoisted_38 = { class: "tpd-action-btn" }
const _hoisted_39 = {
  type: "button",
  class: "edit-btn"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.74422 2.63127C9.19134 2.14685 9.41489 1.90464 9.65245 1.76336C10.2256 1.42246 10.9315 1.41185 11.5142 1.73539C11.7557 1.86948 11.9862 2.10487 12.447 2.57566C12.9079 3.04644 13.1383 3.28183 13.2696 3.52856C13.5863 4.12387 13.5759 4.84487 13.2422 5.43042C13.1039 5.67309 12.8668 5.90146 12.3926 6.35821L6.75038 11.7926C5.85173 12.6581 5.4024 13.0909 4.84084 13.3102C4.27927 13.5296 3.66192 13.5134 2.42722 13.4811L2.25923 13.4768C1.88334 13.4669 1.6954 13.462 1.58615 13.338C1.4769 13.214 1.49182 13.0226 1.52165 12.6397L1.53785 12.4318C1.6218 11.3541 1.66378 10.8153 1.87422 10.3309C2.08466 9.84657 2.44766 9.45328 3.17366 8.6667L8.74422 2.63127Z",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.09375 2.69922L12.2938 6.89922",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.69531 13.5L13.4953 13.5",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_41 = { class: "tpd-action-tooltip" }
const _hoisted_42 = { class: "tpd-action-btn ml-10" }
const _hoisted_43 = {
  type: "button",
  class: "delete-btn"
}
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\" data-v-b75a84cc><path d=\"M12.9154 3.27502L12.4678 9.79134C12.3534 11.4562 12.2963 12.2887 11.8326 12.8871C11.6033 13.183 11.3082 13.4328 10.9659 13.6204C10.2736 14 9.34686 14 7.49346 14C5.63762 14 4.7097 14 4.0169 13.6197C3.67439 13.4317 3.37914 13.1816 3.14997 12.8852C2.68644 12.2857 2.63053 11.4521 2.51869 9.78488L2.08203 3.27502\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-b75a84cc></path><path d=\"M14 3.27502H1\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-b75a84cc></path><path d=\"M10.4282 3.275L9.9352 2.35962C9.60769 1.75157 9.44393 1.44754 9.16146 1.25792C9.0988 1.21586 9.03245 1.17845 8.96307 1.14606C8.65027 1 8.27486 1 7.52404 1C6.75437 1 6.36954 1 6.05154 1.15218C5.98107 1.18591 5.91382 1.22483 5.85048 1.26856C5.56473 1.46586 5.40511 1.78101 5.08588 2.41132L4.64844 3.275\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-b75a84cc></path><path d=\"M5.69336 10.425L5.69336 6.52505\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-b75a84cc></path><path d=\"M9.30469 10.425L9.30469 6.52502\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-b75a84cc></path></svg>", 1)
const _hoisted_45 = { class: "tpd-action-tooltip" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" dashboard-tab-area "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString($data.lms_website.__('Reviews')), 1 /* TEXT */)
      ]),
      _createCommentVNode(" dashboard-tab-area-end "),
      _createCommentVNode(" course-area-start "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString($data.lms_website.__('Course Title')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h4", _hoisted_10, _toDisplayString($data.lms_website.__('Feedback')), 1 /* TEXT */)
              ]),
              _hoisted_11
            ])
          ]),
          ($data.reviews.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14))
            : _createCommentVNode("v-if", true),
          (!$data.reviews.list.length && !$data.reviews.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString($data.lms_website.__('Not Reviews Found')), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($data.reviews.list.length && !$data.reviews.loading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($options.paginatedReviews, (review) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: review.name
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            to: `/courses/view/${review.course.name}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.clip(review.course.title, 40)), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(" " + _toDisplayString($data.moment(review.creation).format("DD, MMMM YYYY - hh:mm a")), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", {
                          class: "course-star-rating star-rating-sm d-inline-block m-0",
                          tooltip: `${(review.rating)}/5`
                        }, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString($data.lms_website.__('Edit')), 1 /* TEXT */),
                          _hoisted_28,
                          _createElementVNode("div", {
                            class: "front-stars",
                            style: _normalizeStyle('width:'+$options.avg_rating_width(review.rating))
                          }, _hoisted_34, 4 /* STYLE */)
                        ], 8 /* PROPS */, _hoisted_26),
                        _createElementVNode("p", _hoisted_35, _toDisplayString(review.review), 1 /* TEXT */)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("button", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("span", _hoisted_41, _toDisplayString($data.lms_website.__('Edit')), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("button", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("span", _hoisted_45, _toDisplayString($data.lms_website.__('Delete')), 1 /* TEXT */)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createCommentVNode(" course-area-start-end "),
      (!$data.reviews.loading)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            "current-page": $data.reviews.currentPage,
            "total-items": $data.reviews.list.length,
            "items-per-page": $data.reviews.itemsPerPage,
            onPageChanged: $options.handlePageChange
          }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" dashboard-content-area-end ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}